module.exports = __webpack_public_path__ + "static/img/empty_icon.ab4f7c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty_icon.png
// module id = /8Vl
// module chunks = 1